package one.healthium.pilates.di

import org.koin.dsl.module

internal actual fun composeAppPlatformModule() = module {
}